module.exports = __webpack_public_path__ + "static/media/howWorks.f6818d8d.svg";